/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { type FetchOptions, type FetchResponse, ofetch } from 'ofetch'
import { apiConfig } from '@/configs/api.config'

export class BaseApi {
  private client

  constructor(baseURL: string = apiConfig.baseURL) {
    this.client = ofetch.create({
      baseURL,

      async onRequest({ options }) {
        const token = localStorage.getItem('sdkjfdg2g8')

        if (token) {
          options.headers = {
            ...options.headers,
            // @ts-expect-error
            Authorization: `Bearer ${token}`,
          }
        }

        // Automatically handle Content-Type for JSON vs FormData
        if (options.body instanceof FormData) {
          // Let the browser set Content-Type for FormData
          options.headers = { ...options.headers }
        } else if (options.body && typeof options.body === 'object') {
          options.headers = {
            // @ts-expect-error
            'Content-Type': 'application/json',
            ...options.headers,
          }

          options.body = JSON.stringify(options.body)
        }
      },

      onResponseError({ response }) {
        BaseApi.handleError(response)
      },
    })
  }
  /** Centralized error handling */
  private static handleError(response: FetchResponse<any>) {
    console.error('API Error:', response._data?.message || response.statusText || 'Unknown error')

    const data = response?._data || {}
    const meta = data?.meta || {}
    throw {
      status: response?.status,
      data,
      meta,
      errors: meta?.errors || {},
      message: meta?.message || data?.message || response.statusText || 'خطای ناشناخته در ارتباط با سرور',
    }
  }

  /** GET */
  async get<T>(url: string, options?: FetchOptions<'json'>): Promise<T> {
    return await this.client<T>(url, { method: 'GET', ...options })
  }

  /** POST */
  async post<T>(
    url: string,
    body?: Record<string, unknown> | FormData | BodyInit | null,
    options?: FetchOptions<'json'>
  ): Promise<T> {
    return await this.client<T>(url, { method: 'POST', body, ...options })
  }

  /** PUT */
  async put<T>(
    url: string,
    body?: Record<string, unknown> | FormData | BodyInit | null,
    options?: FetchOptions<'json'>
  ): Promise<T> {
    return await this.client<T>(url, { method: 'PUT', body, ...options })
  }

  /** PATCH */
  async patch<T>(
    url: string,
    body?: Record<string, unknown> | FormData | BodyInit | null,
    options?: FetchOptions<'json'>
  ): Promise<T> {
    return await this.client<T>(url, { method: 'PATCH', body, ...options })
  }

  /** DELETE */
  async delete<T>(url: string, options?: FetchOptions<'json'>): Promise<T> {
    return await this.client<T>(url, { method: 'DELETE', ...options })
  }
}
